import axios from 'axios';
import _ from 'lodash';

import {
  EMN_SET_CST_ICMS_SUCCESS,
  ENM_SET_CIDADES_FAIL,
  ENM_SET_CIDADES_SUCCESS,
  ENM_SET_ESTRUTURA_DOWNLOAD_FAIL,
  ENM_SET_ESTRUTURA_DOWNLOAD_SUCCESS,
  ENM_SET_METODOS_BUSCA_FAIL,
  ENM_SET_METODOS_BUSCA_SUCCESS,
  ENM_SET_ORIGENS_DOCUMENTO_FISCAL_FAIL,
  ENM_SET_ORIGENS_DOCUMENTO_FISCAL_SUCCESS,
  ENM_SET_PORTAL_ESTADUAL_FAIL,
  ENM_SET_PORTAL_ESTADUAL_SUCCESS,
  ENM_SET_SITUACAO_MANIFESTO_FAIL,
  ENM_SET_SITUACAO_MANIFESTO_SUCCESS,
  ENM_SET_TIPO_CONSULTA_FAIL,
  ENM_SET_TIPO_CONSULTA_SUCCESS,
  ENM_SET_TIPO_DOCUMENTO_CONSULTA_FAIL,
  ENM_SET_TIPO_DOCUMENTO_CONSULTA_SUCCESS,
  ENM_SET_TIPOS_ACESSO_FAIL,
  ENM_SET_TIPOS_ACESSO_SUCCESS,
  ENM_SET_TIPOS_DOCUMENTO_FISCAL_FAIL,
  ENM_SET_TIPOS_DOCUMENTO_FISCAL_SUCCESS,
  ENM_SET_UNIDADES_FEDERATIVAS_FAIL,
  ENM_SET_UNIDADES_FEDERATIVAS_SUCCESS,
  ENM_SET_SITUACAO_XML_MANIFESTO_SUCCESS,
  ENM_SET_SITUACAO_XML_MANIFESTO_FAIL,
} from './types';
import box from '../api/box';
import { sendErroRequest } from '../utils/Notification';

const urlBase = '/v1/enumeradores';
const urlBaseCidade = '/cidades';

export const setTipoAcessoSuccess = payload => ({
  type: ENM_SET_TIPOS_ACESSO_SUCCESS,
  payload,
});

export const setTipoAcessoFail = () => ({
  type: ENM_SET_TIPOS_ACESSO_FAIL,
});

export const setTipoDocumentoFiscalSuccess = payload => ({
  type: ENM_SET_TIPOS_DOCUMENTO_FISCAL_SUCCESS,
  payload,
});

export const setTipoDocumentoFiscalFail = () => ({
  type: ENM_SET_TIPOS_DOCUMENTO_FISCAL_FAIL,
});

export const setUnidadesFederativasSuccess = payload => ({
  type: ENM_SET_UNIDADES_FEDERATIVAS_SUCCESS,
  payload,
});

export const setUnidadesFederativasFail = () => ({
  type: ENM_SET_UNIDADES_FEDERATIVAS_FAIL,
});

export const setOrigemDocumentoFiscalSuccess = payload => ({
  type: ENM_SET_ORIGENS_DOCUMENTO_FISCAL_SUCCESS,
  payload,
});

export const setOrigemDocumentoFiscalFail = () => ({
  type: ENM_SET_ORIGENS_DOCUMENTO_FISCAL_FAIL,
});

export const setDescricaoCstIcmsSuccess = payload => ({
  type: EMN_SET_CST_ICMS_SUCCESS,
  payload,
});

export const setSituacaoManifestoSuccess = payload => ({
  type: ENM_SET_SITUACAO_MANIFESTO_SUCCESS,
  payload,
});

export const setSituacaoManifestoFail = () => ({
  type: ENM_SET_SITUACAO_MANIFESTO_FAIL,
});

export const setSituacaoXMLManifestoSuccess = payload => ({
  type: ENM_SET_SITUACAO_XML_MANIFESTO_SUCCESS,
  payload,
});

export const setSituacaoXMLManifestoFail = () => ({
  type: ENM_SET_SITUACAO_XML_MANIFESTO_FAIL,
});

export const setTipoDocumentoConsultaSuccess = payload => ({
  type: ENM_SET_TIPO_DOCUMENTO_CONSULTA_SUCCESS,
  payload,
});

export const setTipoDocumentoConsultaFail = () => ({
  type: ENM_SET_TIPO_DOCUMENTO_CONSULTA_FAIL,
});

export const setTipoConsultaSuccess = payload => ({
  type: ENM_SET_TIPO_CONSULTA_SUCCESS,
  payload,
});

export const setTipoConsultaFail = () => ({
  type: ENM_SET_TIPO_CONSULTA_FAIL,
});

export const setCidadesSuccess = payload => ({
  type: ENM_SET_CIDADES_SUCCESS,
  payload,
});

export const setCidadesFail = () => ({
  type: ENM_SET_CIDADES_FAIL,
});

export const setMetodoBuscaSuccess = payload => ({
  type: ENM_SET_METODOS_BUSCA_SUCCESS,
  payload,
});

export const setMetodoBuscaFail = () => ({
  type: ENM_SET_METODOS_BUSCA_FAIL,
});

export const setEstruturaDownloadSuccess = payload => ({
  type: ENM_SET_ESTRUTURA_DOWNLOAD_SUCCESS,
  payload,
});

export const setEstruturaDownloadFail = () => ({
  type: ENM_SET_ESTRUTURA_DOWNLOAD_FAIL,
});

export const setPortalEstadualSuccess = payload => ({
  type: ENM_SET_PORTAL_ESTADUAL_SUCCESS,
  payload,
});

export const setPortalEstadualFail = () => ({
  type: ENM_SET_PORTAL_ESTADUAL_FAIL,
});

export const getTipoAcesso = () => async dispatch => {
  try {
    const { data } = await box.get(`${urlBase}/tipos-acesso`);

    dispatch(setTipoAcessoSuccess(data));
  } catch (error) {
    sendErroRequest(error, 'Não foi possível buscar os tipos de acesso');

    dispatch(setTipoAcessoFail());
  }
};

export const getTipoDocumentoFiscal = () => async dispatch => {
  try {
    const { data } = await box.get(`${urlBase}/tipos-documento-fiscal`);

    dispatch(setTipoDocumentoFiscalSuccess(data));
  } catch (error) {
    sendErroRequest(error, 'Não foi possível buscar os tipos de documento fiscal');

    dispatch(setTipoDocumentoFiscalFail());
  }
};

export const getOrigemDocumentoFiscal = () => async dispatch => {
  try {
    const { data } = await box.get(`${urlBase}/origens-documento-fiscal`);

    dispatch(setOrigemDocumentoFiscalSuccess(data));
  } catch (error) {
    sendErroRequest(error, 'Não foi possível buscar as origens de documento fiscal');

    dispatch(setOrigemDocumentoFiscalFail());
  }
};

export const obterDescricaoCSTICMS = cst => async dispatch => {
  try {
    const { data } = await box.get(`${urlBase}/cst-icms/${cst}`);

    let descricao = '';

    if (data === '00') descricao = '00 - Tributada integralmente';
    if (data === '10')
      descricao = '10 - Tributada e com cobrança do ICMS por substituição tributária';
    if (data === '20') descricao = '20 - Com redução de base de cálculo';
    if (data === '30')
      descricao =
        '30 - Tributação Isenta ou não tributada e com cobrança do ICMS por substituição tributária';
    if (data === '40') descricao = '40 - Isenta';
    if (data === '41') descricao = '41 - Não tributada';
    if (data === '50') descricao = '50 - Suspensão';
    if (data === '51') descricao = '51 - Tributação com Diferimento';
    if (data === '60') descricao = '60 - ICMS cobrado anteriormente por substituição tributária';
    if (data === '70')
      descricao =
        '70 - Tributação ICMS com redução de base de cálculo e cobrança do ICMS por substituição tributária';
    if (data === '90') descricao = '90 - Outros';
    if (data === '101')
      descricao = '101 - Tributada pelo Simples Nacional com permissão de crédito';
    if (data === '102')
      descricao = '102 - Tributada pelo Simples Nacional sem permissão de crédito';
    if (data === '103')
      descricao = '103 - Isenção do ICMS no Simples Nacional para faixa de receita bruta';
    if (data === '300') descricao = '300 - Imune';
    if (data === '400') descricao = '400 - Não tributada pelo Simples Nacional';
    if (data === '201')
      descricao =
        '201 - Tributada pelo Simples Nacional com permissão de crédito e com cobrança do ICMS por Substituição Tributária';
    if (data === '202')
      descricao =
        '202 - Tributada pelo Simples Nacional sem permissão de crédito e com cobrança do ICMS por Substituição Tributária';
    if (data === '203')
      descricao =
        '203 - Isenção do ICMS nos Simples Nacional para faixa de receita bruta e com cobrança do ICMS por Substituição Tributária';
    if (data === '500')
      descricao =
        '500 - ICMS cobrado anteriormente por substituição tributária (substituído) ou por antecipação';
    if (data === '900') descricao = '900 - Outros';

    dispatch(setDescricaoCstIcmsSuccess(descricao));
  } catch (error) {
    sendErroRequest(error, 'Não foi possível buscar as origens de documento fiscal');

    dispatch(setOrigemDocumentoFiscalFail());
  }
};

export const getSituacaoManifesto = () => async dispatch => {
  try {
    const { data } = await box.get(`${urlBase}/situacoes-manifesto`);

    dispatch(setSituacaoManifestoSuccess(data));
  } catch (error) {
    sendErroRequest(error, 'Não foi possível buscar os tipos de situação de manifesto');

    dispatch(setSituacaoManifestoFail());
  }
};

export const getSituacaoXMLManifesto = () => async dispatch => {
  try {
    const { data } = await box.get(`${urlBase}/situacoes-documento`);
    dispatch(setSituacaoXMLManifestoSuccess(data));
  } catch (error) {
    dispatch(setSituacaoXMLManifestoFail());
  }
};

export const getUnidadesFederativas = () => async dispatch => {
  try {
    const { data } = await box.get(`${urlBaseCidade}/estados`);

    const estados = data.estados.map(estado => {
      return {
        value: estado.uf,
        label: estado.uf,
      };
    });

    dispatch(setUnidadesFederativasSuccess(estados));
  } catch (error) {
    sendErroRequest(error, 'Não foi possível buscar os estados');

    dispatch(setUnidadesFederativasFail());
  }
};

export const getTipoDocumentoConsulta = () => async dispatch => {
  try {
    const { data } = await box.get(`${urlBase}/tipos-documento-consulta`);

    dispatch(setTipoDocumentoConsultaSuccess(data));
  } catch (error) {
    sendErroRequest(error, 'Não foi possível buscar os tipos de documento da consulta');

    dispatch(setTipoDocumentoConsultaFail());
  }
};

export const getTipoConsulta = () => async dispatch => {
  try {
    const { data } = await box.get(`${urlBase}/tipos-consulta`);

    dispatch(setTipoConsultaSuccess(data));
  } catch (error) {
    sendErroRequest(error, 'Não foi possível buscar os tipos de consulta');

    dispatch(setTipoConsultaFail());
  }
};

export const getCidades = () => async (dispatch) => {
  try {
    const { data } = await axios.get(
      'https://servicodados.ibge.gov.br/api/v1/localidades/municipios',
    );

    const cidades = [];

    for (let i = 0; i < data.length; i++) {
      const cidade = data[i];

      let uf = 'UF desconhecida';

      if (
        cidade &&
        cidade.microrregiao &&
        cidade.microrregiao.mesorregiao &&
        cidade.microrregiao.mesorregiao.UF &&
        typeof cidade.microrregiao.mesorregiao.UF.sigla === 'string'
      ) {
        uf = cidade.microrregiao.mesorregiao.UF.sigla;
      }

      // Valida os dados mínimos antes de adicionar
      if (cidade && cidade.id && cidade.nome) {
        cidades.push({
          value: cidade.id,
          label: cidade.nome,
          uf: uf,
        });
      }
    }

    dispatch(setCidadesSuccess(cidades));
  } catch (error) {
    console.error('Erro ao buscar cidades:', error);
    sendErroRequest(error, 'Não foi possível buscar as cidades');
    dispatch(setCidadesFail());
  }
};



export const getMetodosBusca = () => async dispatch => {
  try {
    const { data } = await box.get(`${urlBase}/metodos-busca`);

    dispatch(setMetodoBuscaSuccess(data));
  } catch (error) {
    sendErroRequest(error, 'Não foi possível buscar os métodos de busca');

    dispatch(setMetodoBuscaFail());
  }
};

export const getEstruturasDownload = () => async dispatch => {
  try {
    const { data } = await box.get(`${urlBase}/estruturas-download`);

    dispatch(setEstruturaDownloadSuccess(data));
  } catch (error) {
    sendErroRequest(error, 'Não foi possível buscar os estruturadas de download');

    dispatch(setEstruturaDownloadFail());
  }
};

export const getPortaisEstadual = () => async dispatch => {
  try {
    const { data } = await box.get(`${urlBase}/portais-estadual`);

    dispatch(setPortalEstadualSuccess(data));
  } catch (error) {
    sendErroRequest(error, 'Não foi possível buscar os portais estaduais');

    dispatch(setPortalEstadualFail());
  }
};
